import React, { useEffect, useState } from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography  from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import moment from 'moment'; 
import { useTranslation } from 'react-i18next';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

import { LabelTransport } from './LabelTransport';

export const CardTransportSection = ({selectedTransport}) => {

  const {t} = useTranslation();

  const [sectionTransportProperties, setSectionTransportProperties] = useState({});
  const [expandedInfo, setExpandedInfo] = useState(false);

  const style = {
    card: {
      display: 'flex',
      width: '90%',
      paddingX: '.2em',
    },
    cardContent: {
      display: 'flex',
      width: '100%'
    },
    contentContainer: { 
      display: 'flex', 
      width: '100%', 
    },
    transportContainer: {
      display: 'flex',
      width: '15%',
      paddingLeft: '1em'
    },
    lineBusInfo: {
      display: 'flex', 
      width: '85%',
      paddingY: '1em'
    },
    transportInfo: {
      display: 'flex', 
      alignItems: 'center',
      flex: 1
    },
    labelContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    label: {
      fontSize: '.9em',
      color: 'black'
    },
    sublabel: {
      fontSize: '.85em',
      color: '#3D3D3D',
      fontWeight: 200
    },
    infoContainer: {
      display: 'flex',
      width: '100%',
    }
  };

  useEffect(() => {
    const {transit_info} = selectedTransport.properties;
    if (transit_info && typeof transit_info === 'string') {
      setSectionTransportProperties(
        {...selectedTransport.properties, 
          transit_info: JSON.parse(selectedTransport.properties.transit_info)
        });
    } else {
      setSectionTransportProperties(selectedTransport.properties);
    }
  }, [selectedTransport]);

  const {transit_info} = sectionTransportProperties || {};
  const {transit_stops, text_color, color, short_name, headsign} = transit_info || [];

  const closeExpandedInfo = () => {
    setExpandedInfo(false);
  };

  const openExpandedInfo = () => {
    setExpandedInfo(true);
  };

  const renderLabel = () => {
    return (
      <Stack sx={{display: 'flex', alignItems: 'center'}} direction='row' spacing={1}>
        <LabelTransport 
          number={short_name} 
          color={color}
          textColor={text_color}
        />
        <Typography sx={{fontSize: '.85em'}}>
          {headsign ?? t('transportDetails.label-unknown')} 
        </Typography>

      </Stack>
    );
  };

  const renderHour = (hour) => {
    const date = moment(hour);
    return date.format('HH:mm');
  };

  const renderListStops = (list) => {
    const sortedTransitStops = list.slice(1, -1);
    return (
      <>
        {sortedTransitStops.map((stop, index) => {
          return (
            <ListItem 
              key={index} 
              sx={{
                display: 'flex', 
                justifyContent: 'space-between',
                paddingX: 0
              }}>
              <Typography sx={{fontSize: '.8em'}}>
                {stop.name}
              </Typography>
              <Typography sx={{fontSize: '.8em'}}>
                {renderHour(stop.departure_date_time ?? stop.arrival_date_time)}
              </Typography>
            </ListItem>
          );
        })}
      </>
    );
  };

  return (
    <Card sx={style.card}>
      <CardContent sx={style.cardContent}>
        <Stack sx={style.contentContainer} direction='column' spacing={1}> 
          {transit_stops && transit_stops.length > 0 && (
            <Box sx={style.labelContainer}>
              <Typography sx={style.label}> 
                {transit_stops[0].name}
              </Typography>
              <Typography sx={style.label}>
                {renderHour(transit_stops[0].departure_date_time)}
              </Typography>
            </Box>
          )}
          <Box sx={style.infoContainer}>
            <Box sx={style.transportContainer}>
              <Box 
                sx={{
                  display: 'flex',
                  width: '.5em',
                  minHeight: '100px',
                  borderRadius: '.5em',
                  backgroundColor: color,
                }}
              />
            </Box>
            <Box sx={style.lineBusInfo}>
              <Stack sx={style.infoContainer} direction='column' spacing={2}>
                <Box sx={{
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'space-between',
                }} 
                >
                  {renderLabel()}
                  {expandedInfo ? (
                    <IconButton aria-label={t('transportDetails.close_stops')} onClick={closeExpandedInfo}>
                      <ExpandLessIcon aria-label='close-stops-icons' />
                    </IconButton>
                  ) : (
                    <IconButton aria-label={t('transportDetails.open_stops')} onClick={openExpandedInfo}>
                      <ExpandMoreIcon aria-label='expand-stops-icons' />
                    </IconButton>
                  )}
                </Box>
                {transit_stops && (
                  <Typography sx={style.sublabel}>
                    {transit_stops.length - 1} {t('transportDetails.stop_label')}
                  </Typography>
                )}
                {transit_stops && transit_stops.length > 2 && (
                  <Collapse in={expandedInfo} unmountOnExit>
                    <List sx={{width: '100%'}} dense>
                      {renderListStops(transit_stops)}
                    </List>
                  </Collapse>
                )}
              </Stack>
            </Box>
          </Box>
          {transit_stops && transit_stops.length > 0 && (
            <Box sx={style.labelContainer}>
              <Typography sx={style.label}> 
                {transit_stops[transit_stops.length -1].name}
              </Typography>
              <Typography sx={style.label}>
                {renderHour(transit_stops[transit_stops.length -1].arrival_date_time)}
              </Typography>
            </Box>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
};